<template>
  <div>
    <p class="title-page">Grupos de E-mail</p>
    <TableGroups />
  </div>
</template>
<script>
import TableGroups from "../components/TableGroups.vue";
export default {
  name: "GruposEmail",

  components: {
    TableGroups,
  },
};
</script>
